// extracted by mini-css-extract-plugin
module.exports =  {"icon":"o6eqZLbJAegGTUw5B_rm"};